import React, { useState, useEffect } from 'react';
import message from '@web-common/components/UI/Message/SiriusMessage';
import style from './MailDeliveryWm.module.scss';
import MdContentSelecter from './components/MdContentSelecter/MdContentSelecter';
import { apiHolder as api, apis } from 'api';
import SiriusModal from '@web-common/components/UI/Modal/SiriusModal';
import { Modal } from 'antd';
import { MailActions, useAppDispatch, useActions } from '@web-common/state/createStore';
import { getIn18Text } from 'api';
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const systemApi = api.api.getSystemApi();
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const accountApi = api.api.requireLogicalApi(apis.accountApiImpl);
const eventApi = api.api.getEventApi();
const MAX_NUM = 500;
const transContactItem2DeliveryBcc = (arr) => {
    const result = arr.map(a => {
        const { email, name } = a || {};
        if (!email) {
            return '';
        }
        return name ? `"${name}" <${email}>` : email;
    });
    return result.filter(s => !!s);
};
export const MailDelivery = (props) => {
    const dispatch = useAppDispatch();
    const reducer = useActions(MailActions);
    const { visible = false, setVisible, mailId, account, way } = props;
    const [errText, setErrText] = useState('');
    const [bcc, setBcc] = useState([]);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (visible) {
            setBcc([]);
            setErrText('');
        }
    }, [visible]);
    const handleCancel = () => {
        setVisible(false);
    };
    const handleOk = toList => {
        if (toList && toList.length > 500) {
            message.success(getIn18Text('ZUIDAFENFSLBNCG5'));
            return false;
        }
        setLoading(true);
        const modal = Modal.info({
            content: React.createElement("span", { style: { fontSize: 16, color: '#272E47' } }, getIn18Text('ZHENGZAIFENFZKNXYYDS6')),
            cancelButtonProps: {
                style: {
                    display: 'none',
                },
            },
        });
        setVisible(false);
        const userInfo = systemApi.getCurrentUser(account);
        mailApi
            .distributeMailWm({
            mid: mailId,
            _account: account,
            to: toList,
            account: userInfo === null || userInfo === void 0 ? void 0 : userInfo.id,
            sid: userInfo === null || userInfo === void 0 ? void 0 : userInfo.sessionId,
            node: userInfo === null || userInfo === void 0 ? void 0 : userInfo.node,
        })
            .then(res => {
            message.success(getIn18Text('FENFACHENGG'));
            reducer.doAddTagAfterDistribute({
                mailId,
            });
            setTimeout(() => {
                eventApi.sendSysEvent({
                    eventName: 'mailMenuOper',
                    eventData: {
                        mailId: mailId,
                    },
                    eventStrData: 'refreshWmMailDelivery',
                    _account: account,
                });
            }, 1000);
        })
            .catch(err => {
            message.error(getIn18Text('FENFASHIB'));
        })
            .finally(() => {
            modal.destroy();
        });
        try {
            trackApi.track('waimao_mail_click_distribute', { way });
        }
        catch (error) {
            console.log('[mail delivery] error', error);
        }
    };
    return (React.createElement(React.Fragment, null, visible ? (React.createElement(SiriusModal, { maskStyle: { top: 0 }, wrapClassName: style.wrap, closable: false, visible: visible, title: getIn18Text('XUANZELIANXIREN'), okButtonProps: { disabled: bcc.length === 0 || loading || errText === getIn18Text('YOUXIANGGESHICUO1') }, cancelButtonProps: { disabled: loading }, okText: getIn18Text('QUEDING'), cancelText: getIn18Text('setting_system_switch_cancel'), width: 680, maskClosable: false, className: style.mailDelivery, footer: null },
        React.createElement(MdContentSelecter, { onOk: handleOk, onCancel: handleCancel, _account: account }))) : null));
};
export default MailDelivery;
